export default __webpack_public_path__ + "static/media/login-page-hero.4c7dfc60.svg";